export default __webpack_public_path__ + "static/media/clock.770dba57.svg";